import React, { useState } from 'react'
import { Carousel } from 'react-bootstrap'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import Agenda1 from '../../images/event/agenda-01.jpg'
import Agenda2 from '../../images/event/agenda-02.jpg'
import Speaker1 from '../../images/event/speaker1.jpg'
import Speaker2 from '../../images/event/speaker2.jpg'
import Speaker3 from '../../images/event/speaker3.jpg'
import Speaker4 from '../../images/event/speaker4.jpg'
import Speaker5 from '../../images/event/speaker5.jpg'

const speakerList = [
  {
    id: 1,
    image: Speaker1,
  },
  {
    id: 2,
    image: Speaker2,
  },
  {
    id: 3,
    image: Speaker3,
  },
  {
    id: 4,
    image: Speaker4,
  },
  {
    id: 5,
    image: Speaker5,
  },
]
const MobileMenu = ({ currentUser }) => {
  const history = useHistory()
  const [tab, setTab] = useState('agenda')
  const [day, setDay] = useState(1)

  const goBack = () => {
    history.goBack()
  }

  return (
    <Page>
      <div className="outer-wrapper">
        <div className="container">
          <div className="title-container">
            <p className="title" />
            <div className="back-button" onClick={goBack}>
              Back
            </div>
          </div>

          <div className="tab-container">
            <p onClick={() => setTab('agenda')} className={tab === 'agenda' ? 'active' : ''}>
              Programme
            </p>
            <p onClick={() => setTab('speakers')} className={tab === 'speakers' ? 'active' : ''}>
              Speakers
            </p>
          </div>
        </div>

        {tab === 'agenda' && (
          <div id="mobile-agenda">
            <div className="agenda">
              <button className={`${day === 1 && 'active'}`} onClick={() => setDay(1)}>
                Day 1 - 25th of Sept
              </button>
              <button className={`${day === 2 && 'active'}`} onClick={() => setDay(2)}>
                Day 2 - 26th of Sept
              </button>
            </div>
            {day === 1 ? <img className="d-block w-100" src={Agenda1} alt="agenda-01" /> : <img className="d-block w-100" src={Agenda2} alt="agenda-02" />}
          </div>
        )}

        {tab === 'speakers' && (
          <div>
            <StyledCarousel>
              {speakerList.map((speaker, index) => (
                <Carousel.Item key={`speaker-${index}`} interval={4000}>
                  <img className="d-block w-100" src={speaker.image} alt={`speaker-${index}`} />
                </Carousel.Item>
              ))}
            </StyledCarousel>
          </div>
        )}
      </div>
    </Page>
  )
}

const StyledCarousel = styled(Carousel)`
  .carousel-control-next,
  .carousel-control-prev {
    opacity: 1;
  }

  .carousel-control-prev {
    left: -5%;
  }
  .carousel-control-next {
    right: -5%;
  }
`

const Page = styled.div`
  background: white;
  height: calc(100% - 60px);
  width: 100vw;
  overflow-y: scroll;
  position: absolute;

  .outer-wrapper {
    width: 100%;
  }

  .container {
    width: 90%;
    margin: auto;
  }

  .title-container {
    margin: 20px 0px 10px 0px;
    height: 50px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  #mobile-agenda {
    width: 90%;
    margin: auto;
    .agenda {
      margin-top: 12px;
      margin-bottom: 10px;
      text-align: center;
      display: flex;
      justify-content: space-around;
      button {
        background: linear-gradient(#ff9821, #f83636);
        color: white;
        border: 2px solid #ff9821;
        font-weight: 500;
        border-radius: 12px;
        padding: 2px 12px;
        font-size: 12px;
      }
      .active {
        font-style: italic;
        color: #002060;
      }
    }
    header {
      text-align: center;
    }
  }

  .title {
    width: 70%;
    font-size: 22px;
    font-weight: bold;
    font-style: italic;
    color: black;
    margin: 0;
  }

  .back-button {
    font-size: 12px;
    color: #312384;
    font-weight: bold;
  }

  .tab-container {
    padding: 5px 0px 20px 0px;
    width: 100%;
    border-bottom: solid 2px #e2cfff;
    margin: auto;
    display: flex;
    justify-content: space-around;
    font-size: 10px;
    font-weight: bold;
    font-style: italic;

    p {
      margin-bottom: 0;
    }

    .active {
      color: #e50000;
    }
  }

  @media screen and (min-width: 540px) {
    .outer-wrapper {
      width: 700px;
      margin: auto;
    }
  }
`

export default MobileMenu
